import { z } from 'zod';

// `validateSearch` de /ccb/criar-cpf-teste e /ccb/excluir-autorizacao (U07, U26): os modais abrem na
// URL, então o voltar fecha. Leve de propósito: é JS inicial.

/** `?overlay=historico` abre o histórico; `?detalhe=<posição>` abre o detalhe de um item da lista. */
export const testToolSearch = z.object({
  overlay: z.enum(['historico']).optional().catch(undefined),
  detalhe: z.coerce.number().int().min(0).max(999).optional().catch(undefined),
});
export type TestToolSearch = z.infer<typeof testToolSearch>;
